import { render, staticRenderFns } from "./nif-driving-license-data.vue?vue&type=template&id=c310c3bc"
import script from "./nif-driving-license-data.vue?vue&type=script&lang=js"
export * from "./nif-driving-license-data.vue?vue&type=script&lang=js"
import style0 from "./nif-driving-license-data.vue?vue&type=style&index=0&id=c310c3bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports